import { useQuery } from '@tanstack/react-query';
import { UseQueryResult } from '@tanstack/react-query';

import { Organization } from '@crossnokaye/typescript-sdk/models/components';
import { ListUserOrgsResponse } from '@crossnokaye/typescript-sdk/models/operations';
import { ListUserOrgsQueryParamView } from '@crossnokaye/typescript-sdk/models/operations';

import { useAtlasClient } from '@/hooks/use-atlas-client';
import { useUser } from '@/hooks/use-user';
import { listUserOrgsQuery } from '@/queries/iam/list-user-orgs-query';

import { getIconNameFromOrgName } from '../utils';
import { removeEnvironmentFromFacilityName } from '../utils';

interface UserOrganization extends Organization {
  iconName: string;
}

const transformUserOrgFacilityList = (data: ListUserOrgsResponse): UserOrganization[] => {
  const userOrgs: UserOrganization[] = [];

  (data.organizationCollection || []).forEach((org) => {
    const facilities = (org.facilities || [])
      .filter((f) => f !== undefined)
      .map((f) => ({
        ...f,
        displayName: removeEnvironmentFromFacilityName(f.displayName),
      }));
    const userOrg: UserOrganization = {
      ...org,
      iconName: getIconNameFromOrgName(org.displayName),
      facilities: facilities.sort((a, b) => a.displayName.localeCompare(b.displayName)),
    };
    userOrgs.push(userOrg);
  });

  return userOrgs;
};

export const useUserOrgFacilityList = (): UseQueryResult<UserOrganization[] | undefined> => {
  const { userId } = useUser();
  const client = useAtlasClient();
  return useQuery(
    listUserOrgsQuery({
      userId,
      view: ListUserOrgsQueryParamView.FacilitiesExtended,
      transform: transformUserOrgFacilityList,
      client,
    })
  );
};
